export type BrandingPreset = {
  id: string;
  name: string;
  description?: string;
  previewColor?: string;
  fonts?: { font_sans?: string; font_serif?: string; font_mono?: string };
  light: Record<string, string>;
  dark?: Record<string, string>;
};

type ThemeModule = { default: BrandingPreset } | BrandingPreset;

const modules = import.meta.glob('./themes/**/theme.json', { eager: true }) as Record<string, ThemeModule>;

function normalizeModule(path: string, mod: ThemeModule): BrandingPreset | null {
  const data = (mod as any).default ?? mod;
  if (!data || typeof data !== 'object') return null;
  const id = data.id || path.split('/').slice(-2, -1)[0];
  return { id, name: data.name || id, description: data.description, previewColor: data.previewColor, fonts: data.fonts, light: data.light || {}, dark: data.dark };
}

export const BRANDING_PRESETS: BrandingPreset[] = Object.entries(modules)
  .map(([path, mod]) => normalizeModule(path, mod))
  .filter((p): p is BrandingPreset => !!p);


